import React from 'react'
import { Radio, RadioGroup, FormControlLabel, Grid } from '@mui/material'

import { Formik, Form } from 'formik'
import { FormikField, StyledButton } from 'shared'

const leaveReasons = [
  { value: '0', title: "I d'ont create content anymore" },
  { value: '1', title: 'I prefer other creator program' },
  { value: '2', title: 'Too many emails and text messages' },
  { value: '3', title: 'Other' },
]

const QuestionStep = ({ closeModal }: { closeModal: () => void }) => {
  const onSubmit = () => undefined

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{ reason: '', reasonDescription: '' }}
    >
      {({ values, setFieldValue }) => {
        const getIsSubmitDisabled = () => {
          if (values.reason === '3') {
            return !values.reasonDescription.length
          }
          return !values.reason
        }
        return (
          <Form>
            {leaveReasons.map((reason) => {
              return (
                <RadioGroup>
                  <FormControlLabel
                    id={reason.value}
                    value={reason.value}
                    label={reason.title}
                    control={<Radio />}
                    checked={reason.value === values.reason}
                    onChange={() => setFieldValue('reason', reason.value)}
                  />
                </RadioGroup>
              )
            })}
            {values.reason === '3' ? (
              <FormikField
                rows={3}
                multiline
                name="reasonDescription"
                placeholder="List issues here"
                value={values.reasonDescription}
                label="Please list any reasons why you might be leaving"
              />
            ) : null}
            <Grid
              container
              justifyContent="flex-end"
              gap="16px"
              marginTop="24px"
            >
              <StyledButton
                color="light"
                variant="contained"
                onClick={closeModal}
              >
                Cancel
              </StyledButton>
              <StyledButton
                color="error"
                variant="contained"
                disabled={getIsSubmitDisabled()}
              >
                Delete
              </StyledButton>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}

export default QuestionStep
